import BaseService from './base.service';

class ProviderTypeService extends BaseService {
  get basePath() {
    return 'provider/types';
  }
}

export default new ProviderTypeService();
